import type {
  Response,
  Over60HoursApplicantResponse,
} from '@/lib/apollo/query/getOver60HoursApplicants/query'
import { parseDate } from '@/utils/date'

import type { TransformedOver60HoursApplicantData, TransformedData } from './types'

export const toTransformedOver60HoursApplicantData = (
  applicant: Over60HoursApplicantResponse,
): TransformedOver60HoursApplicantData => ({
  ...applicant,
  joinedQueueAt: parseDate(applicant.joinedQueueAt),
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined
    ? undefined
    : {
        ...response.getOver60HoursApplicants,
        results: response.getOver60HoursApplicants.results.map(
          toTransformedOver60HoursApplicantData,
        ),
      }
